/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_More_DescriptionInputs */

const da_consent_more_description = /** @type {(inputs: Consent_More_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se, hvad vi gemmer, og hvem der får det, i <a href="/privacy">privatlivspolitikken</a>.`)
};

/** @type {(inputs: Consent_More_DescriptionInputs) => LocalizedString} */
const en_consent_more_description = da_consent_more_description;

/**

* @param {Consent_More_DescriptionInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_more_description = /** @type {((inputs?: Consent_More_DescriptionInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_More_DescriptionInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_more_description(inputs)
	return /** @type {LocalizedString} */ ("Se, hvad vi gemmer, og hvem der får det, i <a href=\"/privacy\">privatlivspolitikken</a>.")
});